<template>
	<v-card flat>
		<v-card-text>
			<div class="d-flex">
				<h3 class="mb-3 d-sm-none">Активность</h3>
				<v-spacer />
				<v-btn
					small
					elevation="0"
					color="transparent"
					@click="fetchActivities()"
				>
					Обновить
					<v-icon small>mdi-refresh</v-icon>
				</v-btn>
			</div>
			<v-divider class="d-sm-none" />
			<v-expansion-panels
				accordion
				multiple
				flat
				tile
			>
				<v-expansion-panel
					v-for="activity in activities.data"
					:key="activity.id"
					style="border-bottom: 1px solid lightgray"
				>
					<v-expansion-panel-header>
						<span>{{ activity.causer.name }}</span>
						<v-spacer />
						<span>{{ $formatDateTime(activity.created_at) }}</span>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<h4 class="mb-1">{{ activity.description }}</h4>
						<template v-if="activityHasChanges(activity)">
							<div
								v-for="(value, key) in activity.properties.changes"
								:key="key"
							>
								<p class="mb-0">{{ fieldsKeyMap[key] }}:</p>
								<code>{{ value.old === null ? '(пусто)' : value.old }}</code>
								<v-icon small class="mx-2">mdi-arrow-right</v-icon>
								<code>{{ value.new }}</code>
							</div>
						</template>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
			<v-pagination
				:value="activities.meta.current_page"
				:length="activities.meta.last_page"
				@input="fetchActivities($event)"
			/>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'RepairOrderShowActivity',
	props: {
		order: {
			type: Object,
			required: true,
		},
	},
	data: () => ({
		loading: false,
		activities: {
			data: [],
			meta: {
				total: 0,
				current_page: 1,
				per_page: 10,
				last_page: 1,
			},
		},
	}),
	computed: {
		fieldsKeyMap() {
			return {
				mechanic_id: 'Механик',
				state: 'Статус',
				contact_phone: 'Контактный телефон',
				contact_name: 'Контактное лицо',
				contact_email: 'Контактный Email',
				client_description: 'Описание неисправности',
				breakage_cause: 'Причина неисправности',
			};
		},
	},
	async mounted() {
		await this.fetchActivities();
	},
	methods: {
		async fetchActivities(page = 1, limit = null) {
			if (this.loading) {
				return;
			}
			this.loading = true;
			limit = limit ? limit : this.activities.meta.per_page;
			try {
				const response = await this.$http.get(`/api/v2/service/orders/repair/${this.order.id}/activities`, {
					params: {
						page,
						limit,
					},
				});

				this.activities = response.data;
			} catch (e) {
				this.$notify.error(e.message);
			} finally {
				this.loading = false;
			}
		},
		activityHasChanges(activity) {
			return !!activity.properties && activity.properties.hasOwnProperty('changes');
		},
	},
};
</script>

<style scoped>

</style>
